import React from 'react';
import { useTranslation } from 'react-i18next';

import { TAG_VARIANTS } from '@private/components';

import { IAccordionHeaderProps } from 'components/Accordion';
import Button from 'components/Button';
import { ICONS_MAP } from 'constants/icons';
import { appReactMemo } from 'hocs';

import { useFilterContext } from '../../../FilterContext';
import { StyledTag } from '../../styled';

import { ArrowIcon, Container, SectionName, Title } from './styled';

interface ISectionHeaderProps extends IAccordionHeaderProps {
  activeCount: number;
  sectionKey: string;
  totalCount: number;
}

const SectionHeader = ({
  activeCount,
  isOpen,
  openHandler,
  sectionKey,
  totalCount,
}: ISectionHeaderProps) => {
  const { t } = useTranslation('translation', { keyPrefix: 'common.filters.sections' });

  const { clearSectionFilters } = useFilterContext();

  const onButtonClick = React.useCallback(() => {
    openHandler(!isOpen);
  }, [openHandler, isOpen]);

  const onClearFilters = React.useCallback(() => {
    clearSectionFilters(sectionKey);
  }, [sectionKey, clearSectionFilters]);

  const tagLabel =
    activeCount === totalCount ? `${totalCount}` : `${activeCount}/${totalCount}`;

  return (
    <Container $isActive={isOpen}>
      <SectionName>
        <Button
          iconSize={10}
          onClick={onButtonClick}
          size='xs'
          startIcon={<ArrowIcon $isActive={isOpen} />}
          variant='icon'
        />
        <Title $isActive={isOpen} size='sm' variant='regular'>
          {t(sectionKey as never)}
        </Title>
      </SectionName>
      {!!totalCount && (
        <StyledTag
          buttonIconSize={7}
          endIcon={<ICONS_MAP.Close />}
          label={tagLabel}
          onEndIconClick={onClearFilters}
          variant={TAG_VARIANTS.PRIMARY}
        />
      )}
    </Container>
  );
};

export default appReactMemo(SectionHeader);
